import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import { LinkListItem } from '.';

import type { LinkListItemProps } from '.';
import type { ComponentType, FC } from 'react';

export interface LinkListItemButtonWithIconProps extends LinkListItemProps {
  icon: ComponentType;
}

/**
 * LinkListItemButton
 * LinkListItem wrapping a List- StyledButton > Text and Icon element
 * @augments LinkListItem
 */

// TODO: make LinkList more composable
// eslint-disable-next-line react/require-default-props
export const LinkListItemButtonWithIcon: FC<
  LinkListItemButtonWithIconProps
> = ({ children, icon: Icon = () => null, ...props }) => (
  <LinkListItem {...props}>
    <ListItemButton>
      <ListItemText>{children}</ListItemText>
    </ListItemButton>
    <ListItemIcon>
      <Icon />
    </ListItemIcon>
  </LinkListItem>
);
